export interface ContextMenuTarget {
    x: number;
    y: number;
    objId: string | null;
    objName: string;
}

class CommandInputStore {
    value = $state("");

    // Incremented by prefill() so InputBar can watch for external sets and focus.
    focusRevision = $state(0);

    // Tab-completion candidates. Set by connection when the server responds.
    completions = $state<string[]>([]);

    // Non-null while the object right-click menu is open.
    contextMenu = $state<ContextMenuTarget | null>(null);

    prefill(text: string) {
        this.value = text;
        this.completions = [];
        this.contextMenu = null;
        this.focusRevision++;
    }

    applyCompletions(words: string[]) {
        this.completions = words;
    }

    openContextMenu(x: number, y: number, objId: string | null, objName: string) {
        this.contextMenu = { x, y, objId, objName };
    }

    closeContextMenu() {
        this.contextMenu = null;
    }
}

export const commandInput = new CommandInputStore();
